'use client'

import React from 'react'
import dynamic from 'next/dynamic'

const Notes = dynamic(() => import('../../components/Plugins/Notes/Notes'), {
  ssr: false
})

export default function NotesPage() {
  return (
    <div style={{ width: 'auto', height: 'auto', padding: '0px' }}>
      <Notes />
    </div>
  )
}
